import { Box, Divider, Typography } from "@mui/material";
import { BasicTooltip } from "@nivo/tooltip";
import { TooltipProps } from "src/components/monitoring/senec-state-history-chart/stateHistoryTypes";
import { dateFormatterWithMilliseconds } from "src/components/monitoring/senec-state-history-chart/stateHistoryChartUtils";

const StateChartTooltip = ({ entry, tooltipText, locale }: TooltipProps) => {
    return (
        <BasicTooltip
            id={
                <Box data-testid="state-chart-tooltip" sx={{ position: "relative", zIndex: 23 }}>
                    <Typography fontWeight="bold" p="0.5rem 0.25rem">
                        {dateFormatterWithMilliseconds(locale.language).format(entry.from)}
                    </Typography>
                    {tooltipText && (
                        <>
                            <Divider orientation="horizontal" sx={{ mb: "0.5rem" }} />
                            <Typography pt={1} pb={1}>
                                {tooltipText}
                            </Typography>
                        </>
                    )}
                </Box>
            }
        />
    );
};

export default StateChartTooltip;
